// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/filestore/v1/filestore.proto" (package "c1.api.filestore.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.filestore.v1.FileRefID
 */
export interface FileRefID {
    /**
     * @generated from protobuf field: string file_id = 1;
     */
    fileId: string;
}
/**
 * @generated from protobuf message c1.api.filestore.v1.FileRefDatasource
 */
export interface FileRefDatasource {
    /**
     * @generated from protobuf field: string datasource_id = 1;
     */
    datasourceId: string;
    /**
     * @generated from protobuf field: string file_name = 2;
     */
    fileName: string;
}
/**
 * @generated from protobuf message c1.api.filestore.v1.FileRefObjectStore
 */
export interface FileRefObjectStore {
    /**
     * @generated from protobuf field: string object_store_id = 1;
     */
    objectStoreId: string;
}
/**
 * @generated from protobuf message c1.api.filestore.v1.File
 */
export interface File {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * @generated from protobuf field: int64 size = 3;
     */
    size: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_modified = 4;
     */
    lastModified?: Timestamp;
    /**
     * @generated from protobuf field: bytes file = 5;
     */
    file: Uint8Array;
    /**
     * @generated from protobuf field: string file_id = 6;
     */
    fileId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp uploaded_at = 7;
     */
    uploadedAt?: Timestamp;
    /**
     * @generated from protobuf field: map<int32, string> hashes = 8;
     */
    hashes: {
        [key: number]: string;
    };
    /**
     * @generated from protobuf oneof: file_ref
     */
    fileRef: {
        oneofKind: "id";
        /**
         * @generated from protobuf field: c1.api.filestore.v1.FileRefID id = 100;
         */
        id: FileRefID;
    } | {
        oneofKind: "datasource";
        /**
         * @generated from protobuf field: c1.api.filestore.v1.FileRefDatasource datasource = 101;
         */
        datasource: FileRefDatasource;
    } | {
        oneofKind: "objectStore";
        /**
         * @generated from protobuf field: c1.api.filestore.v1.FileRefObjectStore object_store = 102;
         */
        objectStore: FileRefObjectStore;
    } | {
        oneofKind: undefined;
    };
}
/**
 * It's important that enum has the same order as the one in the model layer so that the type integers
 * proto/c1/models/filestore/v1/filestore.proto
 *
 * @generated from protobuf enum c1.api.filestore.v1.HashType
 */
export enum HashType {
    /**
     * @generated from protobuf enum value: HASH_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: HASH_TYPE_MD5 = 1;
     */
    MD5 = 1,
    /**
     * @generated from protobuf enum value: HASH_TYPE_SHA256 = 2;
     */
    SHA256 = 2,
    /**
     * @generated from protobuf enum value: HASH_TYPE_ETAG = 3;
     */
    ETAG = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class FileRefID$Type extends MessageType<FileRefID> {
    constructor() {
        super("c1.api.filestore.v1.FileRefID", [
            { no: 1, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.FileRefID
 */
export const FileRefID = new FileRefID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileRefDatasource$Type extends MessageType<FileRefDatasource> {
    constructor() {
        super("c1.api.filestore.v1.FileRefDatasource", [
            { no: 1, name: "datasource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.FileRefDatasource
 */
export const FileRefDatasource = new FileRefDatasource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileRefObjectStore$Type extends MessageType<FileRefObjectStore> {
    constructor() {
        super("c1.api.filestore.v1.FileRefObjectStore", [
            { no: 1, name: "object_store_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.FileRefObjectStore
 */
export const FileRefObjectStore = new FileRefObjectStore$Type();
// @generated message type with reflection information, may provide speed optimized methods
class File$Type extends MessageType<File> {
    constructor() {
        super("c1.api.filestore.v1.File", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "size", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "last_modified", kind: "message", T: () => Timestamp },
            { no: 5, name: "file", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 6, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "uploaded_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "hashes", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 100, name: "id", kind: "message", oneof: "fileRef", T: () => FileRefID },
            { no: 101, name: "datasource", kind: "message", oneof: "fileRef", T: () => FileRefDatasource },
            { no: 102, name: "object_store", kind: "message", oneof: "fileRef", T: () => FileRefObjectStore }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.filestore.v1.File
 */
export const File = new File$Type();
